export enum PanelPosition {
  BLOCKS_SETTINGS = 'BLOCKS_SETTINGS',
  SETTINGS_BLOCKS = 'SETTINGS_BLOCKS',
}
